module.exports = __webpack_public_path__ + "static/channel-8-ef699c71d4d1ce1716ab0e50fddecad0.png";